import Skeleton from '@zenbusiness/zui/Skeleton';
import SkeletonText from '@zenbusiness/zui/SkeletonText';

import { HomeSection } from '#client/components/HomeSection';

function LoadingState() {
  return (
    <HomeSection
      title={(
        <SkeletonText animation="wave" height={36} width="50%" />
      )}
      slots={{
        aside: <SkeletonText animation="wave" height={24} width="6rem" />
      }}
      slotProps={{
        primary: {
          flexDirection: 'row'
        }
      }}
    >
      <Skeleton role="img" height={200} />
    </HomeSection>
  );
}
export default LoadingState;
